import 'i18next';
import i18next from 'i18next';

// English
import common_en from './translations/common.en.json';
import mainLayout_en from './components/layouts/MainLayout/translations/en.json';
import appDetailLayout_en from './components/layouts/AppDetailLayout/translations/en.json';
import appDetailOverview_en from './components/pages/AppDetailOverview/translations/en.json';
import appDetailOwners_en from './components/pages/AppDetailOwners/translations/en.json';
import appDetailSettings_en from './components/pages/AppDetailSettings/translations/en.json';
import appDetailPolicies_en from './components/pages/AppDetailPolicies/translations/en.json';
import appDetailCredentialList_en from './components/pages/AppDetailCredentialList/translations/en.json';
import dashboard_en from './components/pages/Dashboard/translations/en.json';
import myTasks_en from './components/pages/MyTasks/translations/en.json';
import appOverview_en from './components/pages/AppOverview/translations/en.json';
import addCertificatePanel_en from './components/panels/AddCertificatePanel/translations/en.json';
import addPasswordPanel_en from './components/panels/AddPasswordPanel/translations/en.json';
import taskDetailPanel_en from './components/panels/TaskDetailPanel/translations/en.json';

// German
import common_de from './translations/common.de.json';
import mainLayout_de from './components/layouts/MainLayout/translations/de.json';
import appDetailLayout_de from './components/layouts/AppDetailLayout/translations/de.json';
import appDetailOverview_de from './components/pages/AppDetailOverview/translations/de.json';
import appDetailOwners_de from './components/pages/AppDetailOwners/translations/de.json';
import appDetailSettings_de from './components/pages/AppDetailSettings/translations/de.json';
import appDetailPolicies_de from './components/pages/AppDetailPolicies/translations/de.json';
import appDetailCredentialList_de from './components/pages/AppDetailCredentialList/translations/de.json';
import dashboard_de from './components/pages/Dashboard/translations/de.json';
import myTasks_de from './components/pages/MyTasks/translations/de.json';
import appOverview_de from './components/pages/AppOverview/translations/de.json';
import addCertificatePanel_de from './components/panels/AddCertificatePanel/translations/de.json';
import addPasswordPanel_de from './components/panels/AddPasswordPanel/translations/de.json';
import taskDetailPanel_de from './components/panels/TaskDetailPanel/translations/de.json';

// Spanish
import common_es from './translations/common.es.json';
import mainLayout_es from './components/layouts/MainLayout/translations/es.json';
import appDetailLayout_es from './components/layouts/AppDetailLayout/translations/es.json';
import appDetailOverview_es from './components/pages/AppDetailOverview/translations/es.json';
import appDetailOwners_es from './components/pages/AppDetailOwners/translations/es.json';
import appDetailSettings_es from './components/pages/AppDetailSettings/translations/es.json';
import appDetailPolicies_es from './components/pages/AppDetailPolicies/translations/es.json';
import appDetailCredentialList_es from './components/pages/AppDetailCredentialList/translations/es.json';
import dashboard_es from './components/pages/Dashboard/translations/es.json';
import myTasks_es from './components/pages/MyTasks/translations/es.json';
import appOverview_es from './components/pages/AppOverview/translations/es.json';
import addCertificatePanel_es from './components/panels/AddCertificatePanel/translations/es.json';
import addPasswordPanel_es from './components/panels/AddPasswordPanel/translations/es.json';
import taskDetailPanel_es from './components/panels/TaskDetailPanel/translations/es.json';

// French
import common_fr from './translations/common.fr.json';
import mainLayout_fr from './components/layouts/MainLayout/translations/fr.json';
import appDetailLayout_fr from './components/layouts/AppDetailLayout/translations/fr.json';
import appDetailOverview_fr from './components/pages/AppDetailOverview/translations/fr.json';
import appDetailOwners_fr from './components/pages/AppDetailOwners/translations/fr.json';
import appDetailSettings_fr from './components/pages/AppDetailSettings/translations/fr.json';
import appDetailPolicies_fr from './components/pages/AppDetailPolicies/translations/fr.json';
import appDetailCredentialList_fr from './components/pages/AppDetailCredentialList/translations/fr.json';
import dashboard_fr from './components/pages/Dashboard/translations/fr.json';
import myTasks_fr from './components/pages/MyTasks/translations/fr.json';
import appOverview_fr from './components/pages/AppOverview/translations/fr.json';
import addCertificatePanel_fr from './components/panels/AddCertificatePanel/translations/fr.json';
import addPasswordPanel_fr from './components/panels/AddPasswordPanel/translations/fr.json';
import taskDetailPanel_fr from './components/panels/TaskDetailPanel/translations/fr.json';

// Hungarian
import common_hu from './translations/common.hu.json';
import mainLayout_hu from './components/layouts/MainLayout/translations/hu.json';
import appDetailLayout_hu from './components/layouts/AppDetailLayout/translations/hu.json';
import appDetailOverview_hu from './components/pages/AppDetailOverview/translations/hu.json';
import appDetailOwners_hu from './components/pages/AppDetailOwners/translations/hu.json';
import appDetailSettings_hu from './components/pages/AppDetailSettings/translations/hu.json';
import appDetailPolicies_hu from './components/pages/AppDetailPolicies/translations/hu.json';
import appDetailCredentialList_hu from './components/pages/AppDetailCredentialList/translations/hu.json';
import dashboard_hu from './components/pages/Dashboard/translations/hu.json';
import myTasks_hu from './components/pages/MyTasks/translations/hu.json';
import appOverview_hu from './components/pages/AppOverview/translations/hu.json';
import addCertificatePanel_hu from './components/panels/AddCertificatePanel/translations/hu.json';
import addPasswordPanel_hu from './components/panels/AddPasswordPanel/translations/hu.json';
import taskDetailPanel_hu from './components/panels/TaskDetailPanel/translations/hu.json';

// Italian
import common_it from './translations/common.it.json';
import mainLayout_it from './components/layouts/MainLayout/translations/it.json';
import appDetailLayout_it from './components/layouts/AppDetailLayout/translations/it.json';
import appDetailOverview_it from './components/pages/AppDetailOverview/translations/it.json';
import appDetailOwners_it from './components/pages/AppDetailOwners/translations/it.json';
import appDetailSettings_it from './components/pages/AppDetailSettings/translations/it.json';
import appDetailPolicies_it from './components/pages/AppDetailPolicies/translations/it.json';
import appDetailCredentialList_it from './components/pages/AppDetailCredentialList/translations/it.json';
import dashboard_it from './components/pages/Dashboard/translations/it.json';
import myTasks_it from './components/pages/MyTasks/translations/it.json';
import appOverview_it from './components/pages/AppOverview/translations/it.json';
import addCertificatePanel_it from './components/panels/AddCertificatePanel/translations/it.json';
import addPasswordPanel_it from './components/panels/AddPasswordPanel/translations/it.json';
import taskDetailPanel_it from './components/panels/TaskDetailPanel/translations/it.json';

// Dutch
import common_nl from './translations/common.nl.json';
import mainLayout_nl from './components/layouts/MainLayout/translations/nl.json';
import appDetailLayout_nl from './components/layouts/AppDetailLayout/translations/nl.json';
import appDetailOverview_nl from './components/pages/AppDetailOverview/translations/nl.json';
import appDetailOwners_nl from './components/pages/AppDetailOwners/translations/nl.json';
import appDetailSettings_nl from './components/pages/AppDetailSettings/translations/nl.json';
import appDetailPolicies_nl from './components/pages/AppDetailPolicies/translations/nl.json';
import appDetailCredentialList_nl from './components/pages/AppDetailCredentialList/translations/nl.json';
import dashboard_nl from './components/pages/Dashboard/translations/nl.json';
import myTasks_nl from './components/pages/MyTasks/translations/nl.json';
import appOverview_nl from './components/pages/AppOverview/translations/nl.json';
import addCertificatePanel_nl from './components/panels/AddCertificatePanel/translations/nl.json';
import addPasswordPanel_nl from './components/panels/AddPasswordPanel/translations/nl.json';
import taskDetailPanel_nl from './components/panels/TaskDetailPanel/translations/nl.json';

// Polish
import common_pl from './translations/common.pl.json';
import mainLayout_pl from './components/layouts/MainLayout/translations/pl.json';
import appDetailLayout_pl from './components/layouts/AppDetailLayout/translations/pl.json';
import appDetailOverview_pl from './components/pages/AppDetailOverview/translations/pl.json';
import appDetailOwners_pl from './components/pages/AppDetailOwners/translations/pl.json';
import appDetailSettings_pl from './components/pages/AppDetailSettings/translations/pl.json';
import appDetailPolicies_pl from './components/pages/AppDetailPolicies/translations/pl.json';
import appDetailCredentialList_pl from './components/pages/AppDetailCredentialList/translations/pl.json';
import dashboard_pl from './components/pages/Dashboard/translations/pl.json';
import myTasks_pl from './components/pages/MyTasks/translations/pl.json';
import appOverview_pl from './components/pages/AppOverview/translations/pl.json';
import addCertificatePanel_pl from './components/panels/AddCertificatePanel/translations/pl.json';
import addPasswordPanel_pl from './components/panels/AddPasswordPanel/translations/pl.json';
import taskDetailPanel_pl from './components/panels/TaskDetailPanel/translations/pl.json';

// Turkish
import common_tr from './translations/common.tr.json';
import mainLayout_tr from './components/layouts/MainLayout/translations/tr.json';
import appDetailLayout_tr from './components/layouts/AppDetailLayout/translations/tr.json';
import appDetailOverview_tr from './components/pages/AppDetailOverview/translations/tr.json';
import appDetailOwners_tr from './components/pages/AppDetailOwners/translations/tr.json';
import appDetailSettings_tr from './components/pages/AppDetailSettings/translations/tr.json';
import appDetailPolicies_tr from './components/pages/AppDetailPolicies/translations/tr.json';
import appDetailCredentialList_tr from './components/pages/AppDetailCredentialList/translations/tr.json';
import dashboard_tr from './components/pages/Dashboard/translations/tr.json';
import myTasks_tr from './components/pages/MyTasks/translations/tr.json';
import appOverview_tr from './components/pages/AppOverview/translations/tr.json';
import addCertificatePanel_tr from './components/panels/AddCertificatePanel/translations/tr.json';
import addPasswordPanel_tr from './components/panels/AddPasswordPanel/translations/tr.json';
import taskDetailPanel_tr from './components/panels/TaskDetailPanel/translations/tr.json';

declare module 'i18next' {
  interface CustomTypeOptions {
    resources: {
      common: typeof common_en;
      mainLayout: typeof mainLayout_en;
      appDetailLayout: typeof appDetailLayout_en;
      appDetailOverview: typeof appDetailOverview_en;
      appDetailOwners: typeof appDetailOwners_en;
      appDetailSettings: typeof appDetailSettings_en;
      appDetailPolicies: typeof appDetailPolicies_en;
      appDetailCredentialList: typeof appDetailCredentialList_en;
      dashboard: typeof dashboard_en;
      myTasks: typeof myTasks_en;
      appOverview: typeof appOverview_en;
      addCertificatePanel: typeof addCertificatePanel_en;
      addPasswordPanel: typeof addPasswordPanel_en;
      taskDetailPanel: typeof taskDetailPanel_en;
    };
  }
}

type LanguageCode = 'en' | 'de' | 'es' | 'fr' | 'hu' | 'it' | 'nl' | 'pl' | 'tr';

type Resources = import('i18next').CustomTypeOptions['resources'];
type Namespace = keyof Resources;

/**
 * Only English is guaranteed to carry every namespace. A namespace with no bundle for a language is
 * not an error: `@easylife365/react`'s `fallbackLng: 'en'` serves the English text until a translation exists.
 */
type TranslationSet = Partial<Record<Namespace, Record<string, unknown>>>;

// English is typed against the declared namespaces, so a namespace wired to the wrong file does not compile.
type EnglishSet = { [K in Namespace]: Resources[K] };

const translations: Record<Exclude<LanguageCode, 'en'>, TranslationSet> & { en: EnglishSet } = {
  en: {
    common: common_en,
    mainLayout: mainLayout_en,
    appDetailLayout: appDetailLayout_en,
    appDetailOverview: appDetailOverview_en,
    appDetailOwners: appDetailOwners_en,
    appDetailSettings: appDetailSettings_en,
    appDetailPolicies: appDetailPolicies_en,
    appDetailCredentialList: appDetailCredentialList_en,
    dashboard: dashboard_en,
    myTasks: myTasks_en,
    appOverview: appOverview_en,
    addCertificatePanel: addCertificatePanel_en,
    addPasswordPanel: addPasswordPanel_en,
    taskDetailPanel: taskDetailPanel_en,
  },
  de: {
    common: common_de,
    mainLayout: mainLayout_de,
    appDetailLayout: appDetailLayout_de,
    appDetailOverview: appDetailOverview_de,
    appDetailOwners: appDetailOwners_de,
    appDetailSettings: appDetailSettings_de,
    appDetailPolicies: appDetailPolicies_de,
    appDetailCredentialList: appDetailCredentialList_de,
    dashboard: dashboard_de,
    myTasks: myTasks_de,
    appOverview: appOverview_de,
    addCertificatePanel: addCertificatePanel_de,
    addPasswordPanel: addPasswordPanel_de,
    taskDetailPanel: taskDetailPanel_de,
  },
  es: {
    common: common_es,
    mainLayout: mainLayout_es,
    appDetailLayout: appDetailLayout_es,
    appDetailOverview: appDetailOverview_es,
    appDetailOwners: appDetailOwners_es,
    appDetailSettings: appDetailSettings_es,
    appDetailPolicies: appDetailPolicies_es,
    appDetailCredentialList: appDetailCredentialList_es,
    dashboard: dashboard_es,
    myTasks: myTasks_es,
    appOverview: appOverview_es,
    addCertificatePanel: addCertificatePanel_es,
    addPasswordPanel: addPasswordPanel_es,
    taskDetailPanel: taskDetailPanel_es,
  },
  fr: {
    common: common_fr,
    mainLayout: mainLayout_fr,
    appDetailLayout: appDetailLayout_fr,
    appDetailOverview: appDetailOverview_fr,
    appDetailOwners: appDetailOwners_fr,
    appDetailSettings: appDetailSettings_fr,
    appDetailPolicies: appDetailPolicies_fr,
    appDetailCredentialList: appDetailCredentialList_fr,
    dashboard: dashboard_fr,
    myTasks: myTasks_fr,
    appOverview: appOverview_fr,
    addCertificatePanel: addCertificatePanel_fr,
    addPasswordPanel: addPasswordPanel_fr,
    taskDetailPanel: taskDetailPanel_fr,
  },
  hu: {
    common: common_hu,
    mainLayout: mainLayout_hu,
    appDetailLayout: appDetailLayout_hu,
    appDetailOverview: appDetailOverview_hu,
    appDetailOwners: appDetailOwners_hu,
    appDetailSettings: appDetailSettings_hu,
    appDetailPolicies: appDetailPolicies_hu,
    appDetailCredentialList: appDetailCredentialList_hu,
    dashboard: dashboard_hu,
    myTasks: myTasks_hu,
    appOverview: appOverview_hu,
    addCertificatePanel: addCertificatePanel_hu,
    addPasswordPanel: addPasswordPanel_hu,
    taskDetailPanel: taskDetailPanel_hu,
  },
  it: {
    common: common_it,
    mainLayout: mainLayout_it,
    appDetailLayout: appDetailLayout_it,
    appDetailOverview: appDetailOverview_it,
    appDetailOwners: appDetailOwners_it,
    appDetailSettings: appDetailSettings_it,
    appDetailPolicies: appDetailPolicies_it,
    appDetailCredentialList: appDetailCredentialList_it,
    dashboard: dashboard_it,
    myTasks: myTasks_it,
    appOverview: appOverview_it,
    addCertificatePanel: addCertificatePanel_it,
    addPasswordPanel: addPasswordPanel_it,
    taskDetailPanel: taskDetailPanel_it,
  },
  nl: {
    common: common_nl,
    mainLayout: mainLayout_nl,
    appDetailLayout: appDetailLayout_nl,
    appDetailOverview: appDetailOverview_nl,
    appDetailOwners: appDetailOwners_nl,
    appDetailSettings: appDetailSettings_nl,
    appDetailPolicies: appDetailPolicies_nl,
    appDetailCredentialList: appDetailCredentialList_nl,
    dashboard: dashboard_nl,
    myTasks: myTasks_nl,
    appOverview: appOverview_nl,
    addCertificatePanel: addCertificatePanel_nl,
    addPasswordPanel: addPasswordPanel_nl,
    taskDetailPanel: taskDetailPanel_nl,
  },
  pl: {
    common: common_pl,
    mainLayout: mainLayout_pl,
    appDetailLayout: appDetailLayout_pl,
    appDetailOverview: appDetailOverview_pl,
    appDetailOwners: appDetailOwners_pl,
    appDetailSettings: appDetailSettings_pl,
    appDetailPolicies: appDetailPolicies_pl,
    appDetailCredentialList: appDetailCredentialList_pl,
    dashboard: dashboard_pl,
    myTasks: myTasks_pl,
    appOverview: appOverview_pl,
    addCertificatePanel: addCertificatePanel_pl,
    addPasswordPanel: addPasswordPanel_pl,
    taskDetailPanel: taskDetailPanel_pl,
  },
  tr: {
    common: common_tr,
    mainLayout: mainLayout_tr,
    appDetailLayout: appDetailLayout_tr,
    appDetailOverview: appDetailOverview_tr,
    appDetailOwners: appDetailOwners_tr,
    appDetailSettings: appDetailSettings_tr,
    appDetailPolicies: appDetailPolicies_tr,
    appDetailCredentialList: appDetailCredentialList_tr,
    dashboard: dashboard_tr,
    myTasks: myTasks_tr,
    appOverview: appOverview_tr,
    addCertificatePanel: addCertificatePanel_tr,
    addPasswordPanel: addPasswordPanel_tr,
    taskDetailPanel: taskDetailPanel_tr,
  },
};

export const initializeTranslations = (languages?: string[]) => {
  const requested: LanguageCode[] =
    languages && languages.length > 0
      ? (languages.filter((lang): lang is LanguageCode =>
          Object.prototype.hasOwnProperty.call(translations, lang)
        ) as LanguageCode[])
      : (Object.keys(translations) as LanguageCode[]);

  // English is always registered: it is the fallback, and most new text exists nowhere else.
  const langsToInit = Array.from(new Set<LanguageCode>(['en', ...requested]));

  langsToInit.forEach((lang) => {
    const bundles = translations[lang];
    (Object.entries(bundles) as [Namespace, object][]).forEach(([ns, data]) => {
      i18next.addResourceBundle(lang, ns, data, true, true);
    });
  });

  return i18next;
};
